import { render, staticRenderFns } from "./RiskDistribution.vue?vue&type=template&id=936e052c&scoped=true"
import script from "./RiskDistribution.vue?vue&type=script&lang=js"
export * from "./RiskDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936e052c",
  null
  
)

export default component.exports